<template>
  <div
    class="public-gallery"
    v-if="items.length"
    @click="handleFullScreenImage"
  >
    <lingallery
      :mobile-height="400"
      :mobile-height-breakpoint="3000"
      :addons="{ enableLargeView: true, enablePictureElement: true }"
      :items="images"
      :responsive="true"
      :showThumbnails="images.length > 1"
    />
  </div>
</template>

<script>
import settings from '@/settings';
import Lingallery from 'lingallery';

export default {
  components: {
    Lingallery,
  },
  data() {
    return {
      settings: settings,
    };
  },
  props: {
    items: {
      type: Array,
      required: true,
    },
  },
  computed: {
    images() {
      let result = [];

      if (this.items) {
        this.items.forEach((item) => {
          var galleryData = {
            src: this.mixinGetFilePath(item.image, 'O'),
            thumbnail: this.mixinGetFilePath(item.image, 'S'),
          };
          if (item.title) {
            galleryData.caption = item.title;
          }
          result.push(galleryData);
        });
      }
      return result;
    },
  },
  methods: {
    handleFullScreenImage(evt) {
      if (evt.target.matches('img:not([height])')) {
        // need to display fullcreen when image is clicked
        this.$el.classList.remove('fullscreen-hidden');
      } else if (evt.target.matches('#largeViewContainer')) {
        // need to hide fullscreen
        this.$el.classList.add('fullscreen-hidden');
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/assets/scss/components/public/_public-gallery.scss';
</style>
